export { default } from './TextBlockSEO';
